import { render } from "./WelcomeText.vue?vue&type=template&id=021d328d&scoped=true"
import script from "./WelcomeText.vue?vue&type=script&lang=js"
export * from "./WelcomeText.vue?vue&type=script&lang=js"

import "./WelcomeText.vue?vue&type=style&index=0&id=021d328d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021d328d"]])

export default __exports__